import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import Pagination from "react-js-pagination";
import DeleteModal from "../../../components/deleteModal";
import { toast } from "react-toastify";
import {
  customers,
  deleteCustomer,
  getCustomer,
  totalCustomers,
} from "./customerSlice";
import { useCallback } from "react";
import { debounce } from "lodash";

const CustomerList = () => {
  const dispatch = useDispatch();
  // const History = useHistory();

  const [modal, setModal] = useState(false);
  const [id, setDeleteId] = useState("");
  const [filters, setFilters] = useState({
    page: 1,
    limit: 10,
    search: "",
  });
  const data = useSelector(customers);
  const total = useSelector(totalCustomers);

  const listing = useCallback(() => {
    dispatch(getCustomer(filters));
  }, [dispatch, filters]);

  useEffect(() => {
    listing();
  }, [listing]);

  const handlePageChange = (pageNumber) => {
    setFilters({
      ...filters,
      page: pageNumber,
    });
  };

  const handleChange = debounce((e) => {
    setFilters({
      ...filters,
      page: 1,
      search: e.target.value,
    });
  }, 300);

  const toggle = () => {
    setModal(!modal);
  };

  const deleteCat = () => {
    dispatch(deleteCustomer({ id, filters })).then((data) => {
      if (data?.payload?.response_code === 200) {
        toggle();
        toast.success(data.payload.message);
      } else {
        toast.error(data?.payload?.message);
      }
    });
  };
  // const data = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
  return (
    <article class="col-lg-9">
      <div class="article-body store-bd-gy">
        <div class="row align-items-center col-rever">
          <div class="col-sm-6 col-md-6 col-lg-7">
            <div class="link-active">
              <img alt="" src="assets/images/user-big.png" />
              <span>
                <p>{total && total}</p>
                <p>Total Customers</p>
              </span>
            </div>
          </div>
          <div class="col-sm-6 col-md-6 col-lg-5">
            <div class="d-flex align-items-center lg-justify-content-end">
              <form class="has-search">
                <span class="form-search-icon form-control-feedback"></span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search Customer by name"
                  onChange={handleChange}
                />
              </form>
            </div>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive text-center">
              <table class="table storetable">
                <thead class="text-center">
                  <tr>
                    <th scope="col">iD</th>
                    <th scope="col">profile</th>
                    <th scope="col">full Name</th>
                    <th scope="col">mobile number </th>
                    <th scope="col">email address</th>
                    <th scope="col">no.of orders</th>
                    <th scope="col">register date</th>
                    <th scope="col">action</th>
                  </tr>
                  <tr class="border-0 bg-none invisible">
                    <td class="border-0 bg-none"></td>
                  </tr>
                </thead>
                <tbody>
                  {data && data.length > 0 ? (
                    data.map((data, i) => {
                      return (
                        <tr key={i}>
                          <td>{data.bog_id}</td>
                          <td>
                            <div
                              style={{
                                height: "80px",
                                width: "80px",
                                margin: "0 auto",
                                borderRadius: "10px",
                                overflow: "hidden",
                              }}
                            >
                              <img
                                alt=""
                                src={
                                  data?.image?.includes("http")
                                    ? data.image
                                    : "assets/images/employe.png"
                                }
                                class="object-fit-cover"
                              />
                            </div>
                          </td>
                          <td>
                            {(data.first_name && data.first_name + " ") +
                              data.last_name || "N/A"}
                          </td>
                          <td>
                            {(data.country_code && data.country_code + " ") +
                              data.mobile_number || "N/A"}
                          </td>
                          <td>{data.email || "N/A"}</td>
                          <td>{data.orderCount}</td>
                          <td>{data.created_at}</td>
                          <td>
                            <div class="d-flex justify-content-center action">
                              <button class="btn">
                                <Link
                                  to={`/admin/manage-customer/view/${data.id}`}
                                >
                                  <img alt="" src="assets/images/view.png" />
                                </Link>
                              </button>
                              <button
                                onClick={() => {
                                  setDeleteId(data.id);
                                  toggle();
                                }}
                                class="btn"
                              >
                                <img src="assets/images/delete.png" alt="" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={8}>No Data Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {total && total > 10 ? (
          <div>
            <Pagination
              activePage={filters.page}
              itemsCountPerPage={filters.limit}
              totalItemsCount={total}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
            />
          </div>
        ) : (
          ""
        )}
      </div>
      <DeleteModal deleteCategory={deleteCat} modal={modal} toggle={toggle} />
    </article>
  );
};

export default CustomerList;
